/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */
import type {
  HttpResponse as AngularHttpResponse,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { ApplicationDraft, CreateApplicationDraftRequest, UpdateApplicationDraftRequest } from '../../model';

type HttpClientOptions = {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: any;
  params?:
    | HttpParams
    | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
};

@Injectable({ providedIn: 'root' })
export class ApplicationDraftsService {
  constructor(private http: HttpClient) {}
  getApiApplicationDrafts<TData = ApplicationDraft[]>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiApplicationDrafts<TData = ApplicationDraft[]>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiApplicationDrafts<TData = ApplicationDraft[]>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiApplicationDrafts<TData = ApplicationDraft[]>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/ApplicationDrafts`, options);
  }
  postApiApplicationDrafts<TData = void>(
    createApplicationDraftRequest: CreateApplicationDraftRequest,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  postApiApplicationDrafts<TData = void>(
    createApplicationDraftRequest: CreateApplicationDraftRequest,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  postApiApplicationDrafts<TData = void>(
    createApplicationDraftRequest: CreateApplicationDraftRequest,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  postApiApplicationDrafts<TData = void>(
    createApplicationDraftRequest: CreateApplicationDraftRequest,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.post<TData>(`/cvapwebform/api/ApplicationDrafts`, createApplicationDraftRequest, options);
  }
  getApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiApplicationDraftsDraftId<TData = void>(draftId: string, options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/ApplicationDrafts/${draftId}`, options);
  }
  putApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    updateApplicationDraftRequest: UpdateApplicationDraftRequest,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  putApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    updateApplicationDraftRequest: UpdateApplicationDraftRequest,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  putApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    updateApplicationDraftRequest: UpdateApplicationDraftRequest,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  putApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    updateApplicationDraftRequest: UpdateApplicationDraftRequest,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.put<TData>(
      `/cvapwebform/api/ApplicationDrafts/${draftId}`,
      updateApplicationDraftRequest,
      options
    );
  }
  deleteApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  deleteApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  deleteApiApplicationDraftsDraftId<TData = void>(
    draftId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  deleteApiApplicationDraftsDraftId<TData = void>(draftId: string, options?: HttpClientOptions): Observable<TData> {
    return this.http.delete<TData>(`/cvapwebform/api/ApplicationDrafts/${draftId}`, options);
  }
}

export type GetApiApplicationDraftsClientResult = NonNullable<ApplicationDraft[]>;
export type PostApiApplicationDraftsClientResult = NonNullable<void>;
export type GetApiApplicationDraftsDraftIdClientResult = NonNullable<void>;
export type PutApiApplicationDraftsDraftIdClientResult = NonNullable<void>;
export type DeleteApiApplicationDraftsDraftIdClientResult = NonNullable<void>;
